import React, { useMemo } from "react";
import "./TicketId.scss";
import { getTicketManagerFriendlyName } from "../../Ticketing/TicketingUtils";
import { Tooltip } from "@SeemplicityDev/shared";

export interface TicketIdProps {
  id: string;
  className?: string;
  ticketManager?: string;
  logo?: string;
  link?: string;
  onTicketClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
}

const TicketId: React.FC<TicketIdProps> = ({
  id,
  className,
  ticketManager = "",
  logo,
  link = "",
  onTicketClick = () => {},
  disabled = false,
}) => {
  const fullLink = useMemo(() => {
    if (link) {
      return link?.startsWith("https://") ? link : `https://${link}`;
    }
  }, [link]);

  const tooltipContent = !disabled
    ? `View ${id} on ${getTicketManagerFriendlyName(ticketManager)}`
    : "";

  return (
    <div
      className={`ticket-id-container ${logo ? "has-logo" : ""} ${disabled ? "is-disabled" : ""} ${
        className ? className : ""
      }`}
      onClick={!disabled ? onTicketClick : undefined}
    >
      <div className="ticket-id-ellipsis-wrap">
        <div className={"ticket-name"}>
          {logo && (
            <div className={`ticket-id-logo-container`}>
              <img alt={id} src={logo} className="ticket-id-logo" />
            </div>
          )}
          <Tooltip type="info" content={tooltipContent}>
            <a
              href={fullLink || "#"}
              className={`ticket-id-url ${link ? "has-link" : ""}`}
              target={"_blank"}
              rel="noreferrer"
            >
              {id}
            </a>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default TicketId;
